import PropTypes from 'prop-types';

import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import SendSharpIcon from '@mui/icons-material/SendSharp';
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const RawMaterialsFooter = ({ 
  btnText, handleAdd, handleSubmit, showCloneBtn, handleClone 
}) => {
  return(
    <Box mt={2}>
      <Divider 
        sx={{
          '&::before, &::after': {
            borderColor: 'grey.900',
          },
        }}
      >
        <Button
          variant="outlined"
          endIcon={<AddIcon />}
          onClick={handleAdd}
          color="success"
        >
          {btnText}
        </Button>
      </Divider>

      <Stack direction="row" spacing={1} justifyContent="flex-end" mr={1}>
        { showCloneBtn &&
          <Button 
            variant="contained" 
            startIcon={<ContentCopyIcon />} 
            onClick={handleClone}
            color="warning"
          >
            Clone
          </Button>
        }

        <Button 
          variant="contained" 
          endIcon={<SendSharpIcon />} 
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Stack>
    </Box>
  );
};

RawMaterialsFooter.propTypes = {
  btnText: PropTypes.string.isRequired,
  handleAdd: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  showCloneBtn: PropTypes.bool,
  handleClone: PropTypes.func,
};

export default RawMaterialsFooter;